// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".verification[data-v-146d9576]{display:inline-block}.verification .el-button[data-v-146d9576]{width:130px;margin-left:8px}", ""]);
// Exports
module.exports = exports;
